// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function StarIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M29.9 12.161a2 2 0 0 0-1.726-1.375l-7.424-.64-2.91-6.92a1.993 1.993 0 0 0-3.68 0l-2.901 6.92-7.433.644a2 2 0 0 0-1.139 3.508l5.64 4.927-1.69 7.317a2 2 0 0 0 2.98 2.168l6.374-3.875 6.389 3.875a2 2 0 0 0 2.98-2.168l-1.689-7.325 5.638-4.92a2 2 0 0 0 .59-2.136Zm-1.903.625-5.637 4.92a2 2 0 0 0-.635 1.964L23.419 27l-6.384-3.875a1.987 1.987 0 0 0-2.068 0L8.592 27l1.683-7.325a2 2 0 0 0-.635-1.964L4 12.794v-.011l7.43-.643a2 2 0 0 0 1.669-1.219l2.9-6.911 2.9 6.911a2 2 0 0 0 1.67 1.219l7.43.643v.008l-.002-.005Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
